import { createTheme } from '@mui/material/styles';

export const createMinimalistTheme = (mode = 'light') => {
  return createTheme({
    palette: {
      mode,
      primary: {
        main: mode === 'light' ? '#2c6bed' : '#5d8ff2',
        light: mode === 'light' ? '#5d8ff2' : '#81a7f5',
        dark: mode === 'light' ? '#1a56c7' : '#3f6ec9',
        contrastText: '#ffffff',
      },
      secondary: {
        main: mode === 'light' ? '#32354c' : '#a6a9c2',
        light: mode === 'light' ? '#575a72' : '#c8cad9',
        dark: mode === 'light' ? '#232538' : '#8285a6',
        contrastText: '#ffffff',
      },
      background: {
        default: mode === 'light' ? '#f7f9fc' : '#1a1c2a',
        paper: mode === 'light' ? '#ffffff' : '#272a3d',
      },
      text: {
        primary: mode === 'light' ? '#32354c' : '#e6e7f0',
        secondary: mode === 'light' ? '#656782' : '#a6a9c2',
      },
    },
    typography: {
      fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      h1: { fontWeight: 700 },
      h2: { fontWeight: 700 },
      h3: { fontWeight: 600 },
      h4: { fontWeight: 600 },
      h5: { fontWeight: 600 },
      h6: { fontWeight: 500 },
      button: {
        textTransform: 'none',
        fontWeight: 500,
      },
    },
    shape: {
      borderRadius: 10,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            padding: '8px 16px',
            boxShadow: 'none',
            transition: 'all 0.2s',
            '&:hover': {
              boxShadow: mode === 'light' 
                ? '0 4px 12px rgba(44, 107, 237, 0.2)' 
                : '0 4px 12px rgba(93, 143, 242, 0.2)',
            },
          },
          contained: {
            '&:hover': {
              transform: 'translateY(-1px)',
            },
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            boxShadow: mode === 'light'
              ? '0 2px 10px rgba(0, 0, 0, 0.05)'
              : '0 2px 10px rgba(0, 0, 0, 0.2)',
            backgroundColor: mode === 'light' ? '#ffffff' : '#272a3d',
            color: mode === 'light' ? '#32354c' : '#e6e7f0',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            boxShadow: mode === 'light'
              ? '0 4px 15px rgba(0, 0, 0, 0.04)'
              : '0 4px 15px rgba(0, 0, 0, 0.15)',
            transition: 'transform 0.2s, box-shadow 0.2s',
            '&:hover': {
              transform: 'translateY(-3px)',
              boxShadow: mode === 'light'
                ? '0 8px 25px rgba(0, 0, 0, 0.07)'
                : '0 8px 25px rgba(0, 0, 0, 0.2)',
            },
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          rounded: {
            borderRadius: 12,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 6,
            fontWeight: 500,
          },
        },
      },
    },
  });
};